import { render, staticRenderFns } from "./ExternalLinkCreate.vue?vue&type=template&id=4db84b72&"
import script from "./ExternalLinkCreate.vue?vue&type=script&lang=ts&"
export * from "./ExternalLinkCreate.vue?vue&type=script&lang=ts&"
import style0 from "./ExternalLinkCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports